import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
import { isPropertySignature } from "typescript";
import { paymentFailed, paymentSaveAPi } from "../../api/paymentSave";
import FailedImg from "../../assets/payment_failed.svg";
import SucessImg from "../../assets/success_payment.svg";
// ?oid=%3AorderId&amt=1346.0&refId=0002GXN

// /postpayment/t/:token/o/:orderId/p/:paymentId/i/:total/s/:sucess?oid=%3AorderId&amt=1346.0&refId=0002GXN
interface PaymentPrams {
  orderId: string;
  paymentId: string;
  sucess: string;
  token: string;
  total: string;
}

interface PaymentState {
  progress: boolean;
  hasError: boolean;
  error?: string;
  completed: boolean;
}

const PaymentCompletion: React.FC = () => {
  const params = useParams() as PaymentPrams;
  console.log(params);
  const location = useLocation();

  const [state, setState] = useState<PaymentState>({
    completed: false,
    hasError: false,
    progress: false,
  });

  const savePayment = () => {
    console.log("calling api");
    let sO = new URLSearchParams(location.search);
    let oid = sO.get("oid");
    let amt = sO.get("amt");
    let refId = sO.get("refId");
    let ptoken = sO.get("ptoken");
    // call save payemt here
    if (params.orderId === oid) {
      setState((s) => ({
        ...s,
        progress: true,
      }));
      paymentSaveAPi(params.token, params.orderId, params.paymentId, {
        amount: amt ?? "0",
        token: ptoken ?? null,
        tranId: refId ?? null,
      })
        .then((res) => {
          if (res.status === 200) {
            let data = res.data;
            let ress: {
              message1: string;
              message2: string;
              message3: string;
              severity: string;
              status: number;
              summary: string;
            } = {
              message1: data["message1"] ?? "",
              message2: data["message2"] ?? "",
              message3: data["message3"] ?? "",
              severity: data["message1"] ?? "",
              status: data["status"] ?? 2,
              summary: data["summary"] ?? "",
            };

            if (ress.status !== 1) {
              let error_description = ress.message1 ?? "unknown Error";

              setState((s) => ({
                ...s,
                completed: false,
                error: `${error_description} Ref:${ress.summary}`,
                hasError: true,
                progress: false,
              }));
            } else {
              setState((s) => ({
                ...s,
                completed: true,
                progress: false,
              }));
            }
          } else {
            let responseData = res.data;
            // let errorText = responseData['error']??''
            let error_description = responseData["error"] ?? "unknown Error";

            setState((s) => ({
              ...s,
              completed: false,
              error: `${error_description} Ref:${error_description}`,
              hasError: true,
              progress: false,
            }));
          }
        })
        .catch((e) => {
          setState({
            completed: false,
            error: `${e} RefId : ${refId} `,
            hasError: true,
            progress: false,
          });
        });
    }
  };
  const saveFailedPayment = () => {
    console.log("calling api");
    // call save payemt here
    let sO = new URLSearchParams(location.search);
    let err = sO.get("err") ?? "Unknown Reason";
    paymentFailed(params.token, params.orderId, params.paymentId, err);
  };

  useEffect(() => {
    // for esewa
    if (params.sucess === "1" && location.search.length > 0) {
      savePayment();
    } else if (params.sucess === "0") {
      saveFailedPayment();
    }
  }, [location, params.sucess]);

  if (params.sucess === "1") {
    return (
      <>
        <Container
          maxWidth={"sm"}
          sx={{
            display: "flex",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {state.progress ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
              <Typography sx={{ ml: 1 }}>Verifying Your payment</Typography>
            </Box>
          ) : state.hasError ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img
                src={FailedImg}
                alt="failed"
                style={{ width: "40vw", objectFit: "cover" }}
              />
              <Typography textAlign={"center"} variant="h6" fontWeight={400}>
                Verification Failed {state.error}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  mt: 1,
                }}
              >
                <Button
                  variant={"outlined"}
                  sx={{ mr: 1 }}
                  component={"a"}
                  href={"https://foodmood.com.np/home"}
                >
                  Cancel
                </Button>
                <Button
                  variant={"contained"}
                  color={"success"}
                  onClick={savePayment}
                >
                  Retry
                </Button>
              </Box>
            </Box>
          ) : state.completed ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img
                src={SucessImg}
                alt="sucess"
                style={{ width: "40vh", objectFit: "cover" }}
              />
              <Typography textAlign={"center"} variant="h6">
                Your Payment was Successful .
              </Typography>
              <Button
                fullWidth
                variant={"contained"}
                component={"a"}
                href={"https://foodmood.com.np/home"}
              >
                TO APP
              </Button>
            </Box>
          ) : (
            <>Something went wrong . Please contact Admin</>
          )}
        </Container>
      </>
    );
  } else {
    let sO = new URLSearchParams(location.search);
    let error = sO.get("err");
    return (
      <>
        <Container
          maxWidth={"sm"}
          sx={{
            display: "flex",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <img
              src={FailedImg}
              alt="failed"
              style={{ width: "40vw", objectFit: "cover" }}
            />
            <Typography textAlign={"center"} variant="h6">
              Payment Failed
              {error}
            </Typography>
            <Button
              fullWidth
              variant={"contained"}
              component={"a"}
              href={"https://foodmood.com.np/home"}
            >
              TO APP
            </Button>
          </Box>
        </Container>
      </>
    );
  }
};

export default PaymentCompletion;
